import { useEffect } from 'react'
import { useAuth } from '@/context/auth-context'

export function LogoutPage() {
  const { logout } = useAuth()
  
  useEffect(() => {
    // Clear all authentication data
    localStorage.removeItem('auth_token')
    sessionStorage.removeItem('auth_token')
    localStorage.setItem('force_logout', 'true')
    localStorage.setItem('skip_dev_auto_login', 'true')
    
    // Remove any auth headers
    // We don't need to clear axios headers here as that's handled in the logout function
    
    // Call the logout function
    logout()
    
    // Force a hard refresh to the login page
    window.location.href = '/login'
  }, [logout])
  
  return (
    <div className="flex min-h-screen flex-col items-center justify-center bg-background">
      <div className="animate-spin rounded-full h-8 w-8 border-t-2 border-b-2 border-primary"></div>
      <p className="mt-4">Logging out...</p>
    </div>
  )
}
